module.exports = __webpack_public_path__ + "static/media/client6.bbe719f0.avif";